// extracted by mini-css-extract-plugin
export default {"tagsRow":"oeTxOC","moreButton":"Wp_pTD","leftAligned":"EahZhx","rightAligned":"VZlv5u","tag":"FzuF4g"};